import React, { useCallback, useEffect, useState } from 'react'
import { Image, View, Text } from 'react-native'
import Wrapper from '../../Wrapper'
import { FAB } from 'react-native-paper'
import { HEADER_HEIGHT } from '..'
import { ListPlaceholder } from '../../../../ui/atoms/ListPlaceholder'
import { useIsFocused, useNavigation } from '@react-navigation/core'
import { BackHeader, IconDelete } from '../../../../assets/icons'
import { routes } from '../../../../../../models'
import { CommonActions } from '@react-navigation/routers'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import Loading from '../../../Loading'
import SwipableListItem from '../../../../ui/molecules/SwipableListItem'
import { DeleteListItemIcon } from '../../../../assets/icons'
import moment from 'moment'
import { ConfirmPrompt } from '../../../../ui/molecules/ConfirmPrompt'
import { theme } from '@linqpal/common-frontend'
import noProjectsImage from '../../../../assets/images/builder2.0/MoreProjects.svg'
import { paths } from '../../../links'
import { useTranslation } from 'react-i18next'

const backBehavior = (navigation) => {
  if (navigation.canGoBack()) {
    navigation.goBack()
  } else {
    navigation.dispatch({
      ...CommonActions.reset({
        index: 0,
        routes: [
          {
            name: 'More',
          },
        ],
      }),
    })
  }
}
const ProjectsHeader = () => {
  const { t } = useTranslation('global')
  const navigation = useNavigation()
  return (
    <View
      style={{
        height: HEADER_HEIGHT,
        marginBottom: 27,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        borderBottom: '1px solid #F5F7F8',
      }}
    >
      <GetIcon
        icon={<BackHeader height="16" width="16" />}
        onPress={() => backBehavior(navigation)}
      />
      <Text style={{ fontWeight: '600', fontSize: 18 }}>
        {t('Projects.projects')}
      </Text>
      <View style={{ width: 40 }}></View>
    </View>
  )
}

const { commonColors } = theme

export const ProjectListing = ({ navigation }) => {
  const { t } = useTranslation('global')
  const isFocused = useIsFocused()

  const [loading, setLoading] = useState(true)
  const [projects, setProjects] = useState([])
  const [projectToDelete, setProjectToDelete] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [width, setWidth] = useState(0)

  useEffect(() => {
    const req = routes.projects.list({})
    req
      .then((res) => {
        setProjects(res.projects)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }, [isFocused])

  const deleteProject = () => {
    console.log('projectToDelete._id', projectToDelete._id)
    const req = routes.projects.deleteProject(projectToDelete._id)
    req
      .then((res) => {
        console.log(res)
        setDeleteModal(false)
      })
      .then(() => setLoading(true))
      .then(() => routes.projects.list({}))
      .then((res) => {
        setProjects(res.projects)
        setLoading(false)
      })
      .catch((err) => {
        setLoading(false)
      })
  }

  const onLayout = useCallback((e) => {
    const { x, y, width: w } = e.nativeEvent.layout
    setWidth(w)
  }, [])

  if (loading) {
    return <Loading />
  }
  return (
    <>
      <Wrapper toolbar={<ProjectsHeader />} onLayout={onLayout}>
        {!projects.length && !loading && (
          <ListPlaceholder
            image={
              <Image
                style={{
                  width: 174,
                  height: 114,
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
                source={noProjectsImage}
              />
            }
            heading={t('Projects.no_projects')}
            subHeading={t('Projects.sub_heading')}
            style={{ paddingBottom: HEADER_HEIGHT }}
          />
        )}
        {!!projects.length &&
          !loading &&
          projects.map((project) => (
            <SwipableListItem
              key={project._id}
              title={project.name}
              left={() => <></>}
              rightActions={[
                {
                  icon: <DeleteListItemIcon size={24} />,
                  handler: () => {
                    setProjectToDelete(project)
                    setDeleteModal(true)
                  },
                },
              ]}
              rightActionStyle={{ marginBottom: 20 }}
              titleStyle={{ fontWeight: '500', lineHeight: 24 }}
              descriptionStyle={{ lineHeight: 20 }}
              style={{ borderRadius: 12, marginBottom: 16, fontSize: 12 }}
              onPress={() => {
                navigation.navigate(paths.Console.Projects.Details, {
                  project: project,
                })
              }}
              description={`${t('Projects.added')} ${moment(
                project.createdAt,
              ).fromNow()}`}
              rightComponent={
                <Text
                  style={{
                    alignSelf: 'center',
                    fontSize: 16,
                    fontWeight: '500',
                  }}
                >
                  {project.invoices.length} {t('Projects.invoices')}
                </Text>
              }
            />
          ))}
        <ConfirmPrompt
          visible={deleteModal}
          icon={<IconDelete />}
          onDismiss={() => {
            setDeleteModal(false)
          }}
          title={t('Projects.confirm_action')}
          message={t('Projects.confirm_message')}
          firstButton={{
            title: 'Cancel',
            mode: 'contained',
            bgColor: 'rgba(242, 90, 104, 0.1)',
            textColor: '#DA515E',
            onPress: () => {
              setDeleteModal(false)
            },
          }}
          secondButton={{
            title: 'Yes, delete',
            mode: 'contained',
            bgColor: commonColors.accentText,
            onPress: () => {
              deleteProject()
            },
          }}
        />
      </Wrapper>
      <FAB
        style={{
          position: 'absolute',
          bottom: 76,
          left: width * 0.8,
          backgroundColor: '#00A0F3',
        }}
        icon="plus"
        onPress={() => navigation.navigate(paths.Console.Projects.Form)}
      />
    </>
  )
}
